$(function() {
  function toggleMore() {
    if ($('.search-refine__more-content').is(':visible')) {
      $('.search-refine-more').show();
      $('.search-refine-less').hide();
    } else {
      $('.search-refine-more').hide();
      $('.search-refine-less').show();
    }
    $('.search-refine__more-content').slideToggle();
  }

  function showSortMobile() {
    $('.search-sort').removeClass('hidden');
    $('.search-results-cards').hide();
    $('.custom-container').hide();
    $('.footer').hide();
  }

  function showMobileFilter() {
    $('.search-refine').removeClass('hidden-xs');
    $('.search-refine').addClass('show');
    $('.search-results-cards').hide();
    $('.custom-container').hide();
    $('.footer').hide();
  }

  function applyFilter() {
    $('.search-refine__form').submit();
  }

  function checkProductNameLength() {
    if ($('.search-results-category-heading').length) {
      var searchResultCategoryEle = $(
        '.search-results-category-heading .search-results-breadcrumb-item'
      );
      searchResultCategoryEle.removeClass('hidden');
      ACC.utility.setEllipsis(searchResultCategoryEle);
    }
  }
  checkProductNameLength();
  $('.search-refine-apply-col__btn').on('click', applyFilter);
  $('.search-results-cards-filter-col-btn').on('click', showMobileFilter);
  $('.search-results-sortCol-button').on('click', showSortMobile);
});
